import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type JiraIssuesCountQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.JiraIssueFilters>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
}>;


export type JiraIssuesCountQuery = { jiraIssues: { totalCount: number } };


export const JiraIssuesCountDocument = /*#__PURE__*/ gql`
    query jiraIssuesCount($filters: JiraIssueFilters, $first: Float, $after: String, $sort: [SortType!]) {
  jiraIssues(sort: $sort, filters: $filters, first: $first, after: $after) {
    totalCount
  }
}
    `;

export function useJiraIssuesCountQuery(options?: Omit<Urql.UseQueryArgs<JiraIssuesCountQueryVariables>, 'query'>) {
  return Urql.useQuery<JiraIssuesCountQuery, JiraIssuesCountQueryVariables>({ query: JiraIssuesCountDocument, ...options });
};